import OrderDetails from "../components/order-details/order-details";
import Wrapper from "../components/common/wrapper/wrapper";

export const OrderPage = () => {

  return (
    <Wrapper>
      <OrderDetails/>
    </Wrapper>
  )
}
